import * as Yup from "yup"
import { NewslineKeys } from "../../../models/knowledgeBase/newsline"
import { NEWLINE_DESCRIPTION_REGEXP } from "../constants"
import { NEWSLINE_FORM_CONST } from "../NewslineForm.const"

const { tNamespace, tPaths } = NEWSLINE_FORM_CONST

export const NewslineFormSchema = Yup.object().shape({
    [NewslineKeys.lifeTime]: Yup.number()
        .when(NewslineKeys.isEndless, {
            is: false,
            then: Yup.number().notOneOf([0], `${tNamespace}:${tPaths.form.error.lifeTime}`)
        })
        .test("lessThanNow", `${tNamespace}:${tPaths.form.error.lifeTimeLessThanNow}`, function (value) {
            const { [NewslineKeys.isEndless]: isEndless } = this.parent

            if (isEndless) {
                return true
            }

            return value !== undefined && value !== null && value > Date.now()
        }),
    [NewslineKeys.description]: Yup.string().matches(NEWLINE_DESCRIPTION_REGEXP, {
        message: `${tNamespace}:${tPaths.form.error.description}`,
        excludeEmptyString: true
    })
})
